import catchWrapper from 'common/utils/catchWrapper'

const urlParameter = (name) => catchWrapper(() => window.EF.urlParameter(name)) || null

/**
 * Transaction id for the offer, from the landing page handoff first and the SDK's own storage second.
 *
 * @param {string} offerId
 * @returns {string|null}
 */
export const transactionId = (offerId) =>
  urlParameter('_ef_transaction_id') || catchWrapper(() => window.EF.getTransactionId(offerId)) || null
